import { cn } from '@/shared/lib'

export interface HeroImageCredit {
  name: string
  url?: string
  author?: string
}

/**
 * A full-bleed banner: breaks out of the page's centered `max-w-5xl` column
 * (`App.tsx`'s `<main>`) to run edge to edge, with an optionally-linked
 * credit for the image in the bottom corner.
 */
export function HeroImage({ src, alt, credit, className }: {
  src?: string
  alt?: string
  credit?: HeroImageCredit
  className?: string
}) {
  return (
    <div
      data-slot="hero-image"
      className={cn(
        // Taller (smaller ratio) on narrow screens, where a 6:1 strip reads as a sliver;
        // widens back out toward 6:1 as there's room for it.
        'relative mx-[calc(50%-50vw)] aspect-[3/1] w-screen overflow-hidden bg-gradient-to-br from-primary/20 via-muted to-accent/20 sm:aspect-[4/1] md:aspect-[5/1] lg:aspect-[6/1]',
        className,
      )}
    >
      {src && <img src={src} alt={alt ?? ''} className="absolute inset-0 h-full w-full object-cover" />}
      {credit?.name && (
        <div
          data-slot="hero-image-credit"
          className="absolute bottom-2 right-3 rounded bg-background/70 px-2 py-1 text-xs text-foreground backdrop-blur-sm"
        >
          {credit.url ? (
            <a
              href={credit.url}
              target="_blank"
              rel="noreferrer noopener"
              className="underline underline-offset-2 hover:text-link"
            >
              {credit.author ? `by ${credit.author} on ${credit.name}` : credit.name}
            </a>
          ) : (
            credit.author ? `by ${credit.author} on ${credit.name}` : credit.name
          )}
        </div>
      )}
    </div>
  )
}
